import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Button from '../Button'
import cx from 'classnames'
import AnimateIn from '../AnimateIn'

const LayoutCallToAction = ({ data, isAnimated }) => {
  const desktopImage = data.v1CoverImageDesktop
    ? data.v1CoverImageDesktop?.gatsbyImageData
    : data.v1CoverImageDesktop2x?.gatsbyImageData
  const mobileImage = data.v1CoverImageMobile
    ? data.v1CoverImageMobile?.gatsbyImageData
    : data.v1CoverImageMobile2x?.gatsbyImageData
  const backgroundColor = data.v1BackgroundColor ? data.v1BackgroundColor : null

  if (data.stylingOption === 'V1') {
    return (
      <div
        className={cx(
          'relative flex text-white min-h-[600px] sm:min-h-[700px] md:min-h-[750px]',
          data.noMarginBottom === 1 ? null : 'mb-11'
        )}
      >
        {mobileImage ? (
          <GatsbyImage
            className="absolute inset-0 block lg:hidden"
            alt=""
            objectFit={
              data.v1ImageMobileObjectFit
                ? data.v1ImageMobileObjectFit
                : 'contain'
            }
            imgClassName="object-bottom"
            backgroundColor={backgroundColor}
            image={mobileImage}
          />
        ) : null}
        {desktopImage ? (
          <GatsbyImage
            className="absolute inset-0 hidden lg:block"
            alt=""
            backgroundColor={backgroundColor}
            image={desktopImage}
          />
        ) : null}
        <div
          className={cx(
            'container relative z-0 text-center flex justify-center w-full pt-20 lg:pt-0 lg:items-center',
            {
              'lg:justify-start lg:text-left':
                data.v1TextAlignment === 'left' || !data.v1TextAlignment,
              'lg:justify-center lg:text-center':
                data.v1TextAlignment === 'center',
              'lg:justify-end lg:text-left': data.v1TextAlignment === 'right',
            }
          )}
        >
          <AnimateIn
            disabled={!isAnimated}
            distance={30}
            transformDuration={1000}
            opacityDuration={1000}
            threshold={0.3}
          >
            <div className="md:w-3/5 lg:w-2/5">
              <h2>
                <span className="block">{data.v1Heading}</span>
                {data.v1HeadingLine2 ? (
                  <span className="block">{data.v1HeadingLine2}</span>
                ) : null}
              </h2>
              <div
                className="mt-4 text-lg leading-normal lg:text-2xl"
                dangerouslySetInnerHTML={{
                  __html: data.v1Description.childMarkdownRemark.html,
                }}
              />
              <div className="mt-6">
                {data?.v1Buttons?.length > 0 ? (
                  <Button {...data.v1Buttons[0]} className="mx-auto" />
                ) : null}
              </div>
            </div>
          </AnimateIn>
        </div>
      </div>
    )
  }

  if (data.stylingOption === 'V2') {
    return (
      <div className="flex flex-col text-center text-white lg:flex-row">
        <div className="px-6 bg-pink-500 lg:w-1/2 py-30">
          {data.v2Column1Heading ? <h2>{data.v2Column1Heading}</h2> : null}
          {data.v2Column1Description ? (
            <div
              className="py-6 mx-auto text-lg leading-tight lg:text-2xl max-w-[360px]"
              dangerouslySetInnerHTML={{
                __html: data.v2Column1Description.childMarkdownRemark.html,
              }}
            />
          ) : null}
          {data.v2Column1Button ? (
            <Button {...data.v2Column1Button} className="mx-auto" />
          ) : null}
        </div>
        <div className="px-6 lg:w-1/2 py-30 bg-blueLight-500">
          {data.v2Column2Heading ? <h2>{data.v2Column2Heading}</h2> : null}
          {data.v2Column2Description ? (
            <div
              className="py-6 mx-auto text-lg leading-tight text-white lg:text-2xl max-w-[360px]"
              dangerouslySetInnerHTML={{
                __html: data.v2Column2Description.childMarkdownRemark.html,
              }}
            />
          ) : null}
          {data.v2Column2Button ? (
            <Button {...data.v2Column2Button} className="mx-auto" />
          ) : null}
        </div>
      </div>
    )
  }

  return null
}

export default LayoutCallToAction
